// import { gql } from 'graphql-request';

export const findOnePatientQuery = (props: { document: string }) => ({
  query: `
  query FindOnePatient {
    findOnePatient(filter:{ document: "${props.document}" }) {
      edges {
        node {
          name,
          healthProfessionals {
            id
            name
            userIdPortal
            catalogId
            specialities {
              id
              name
            }
          }
        }
      }
    }
  }
`
});
